<template>
  <div>
    <el-drawer @reload="$reloadHandle"
               title="物流单号"
               size="30%"
               :before-close="handleClose"
               :visible.sync="drawer"
               direction="rtl"
               :modal-append-to-body="true"
               custom-class="demo-drawer"
               ref="drawer"
    >

      <div class="demo-drawer__content">
        <el-form :model="formData">
          <el-row>
            <el-col :span="12">
              <el-form-item label="物流单号" name="remark" :rules="{required: true}">
                <el-input type="text"
                          v-model="formData.deliverNo"
                          autocomplete="off"
                ></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="12">
              <el-form-item label="物流公司" :rules="{required: true}">
                <dict-select :dict-item-id.sync="formData.deliverCompany"
                             :dict-item-name.sync="formData.deliverCompanyName"
                             dict-type="物流公司"
                             style="width: 100%"
                />
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
        <div class="demo-drawer__footer" style="position: absolute;
    bottom: 5px;
    right: 5px;">
          <el-button @click="cancelForm">取 消</el-button>
          <el-button type="primary" @click="close">
            确 定
          </el-button>
        </div>
      </div>
    </el-drawer>

  </div>
</template>
<script>
import api from "@/api/projectApi";
import DictSelect from "@/components/formItem/dictSelect.vue";

export default {
  name: 'setDeliverNoDialog',
  components: {DictSelect},
  props: ['multi', 'dataId', 'type'],
  created() {
    this.formData.id = this.dataId
  },
  mounted() {
    this.getInWarehouseData()
  },
  data() {
    return {
      formData: {
        deliverNo: null,
        id: null,
        deliverCompany: null,
        deliverCompanyName: null
      },
      drawer: true,
    }
  },
  methods: {


    close() {
      let rules = {
        deliverNo: [{prop: '物流单号', required: true}],
        deliverCompany: [{prop: '物流公司', required: true}],
        deliverCompanyName: [{prop: '物流公司id', required: true}],
      }

      this.$validate(this.formData, rules).then(() => {
        this.$mask.open()
        this.$http({
          url: api.spPartsApplyHeader.setDeliverNoUrl,
          method: 'post',
          data: this.formData
        }).then(res => {
          this.$message.success('操作成功')
          this.handleClose()
          this.$emit('goBackIndex')
          this.$mask.close()
        }).catch(() => {
          this.$mask.close()
        })
      })
    },




    confirm() {
      this.drawer = false;
      this.handleClose()
    },
    cancelForm() {
      this.handleClose()
    },
    handleClose() {
      this.visiable = false
      this.$emit('update:visiable', this.visiable)
    }
  }
}
</script>
<style lang="scss" scoped>
::v-deep .el-drawer .el-drawer__body {
  padding: 0 16px;
  background-color: #fff;
  position: relative;
}

::v-deep .el-drawer .el-drawer__header {
  background-color: #fff;
}

::v-deep .el-drawer__container {
  position: relative;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  height: 100%;
  width: 100%;
  background: aliceblue;
  background-color: rgb(38 38 38 / 70%);
}

#containt .table-detail {
  border-collapse: collapse;
  font-size: 12px;
  border: 1px solid #ededed;
}

.btn {
  text-align: center;
}

::v-deep .el-select {
  width: 100%;
}
</style>
